export const UserRoles = {
  SuperAdmin: 'super_admin',
  Admin: 'admin',
  Maker: 'maker',
  Approver: 'approver',
};
